export default __webpack_public_path__ + "static/media/badge-new.76302f01.svg";